import { render, staticRenderFns } from "./facility.vue?vue&type=template&id=39841a38&scoped=true&"
import script from "./facility.vue?vue&type=script&lang=js&"
export * from "./facility.vue?vue&type=script&lang=js&"
import style0 from "./facility.vue?vue&type=style&index=0&id=39841a38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39841a38",
  null
  
)

component.options.__file = "facility.vue"
export default component.exports